import { render, staticRenderFns } from "./CaseDetailsData.vue?vue&type=template&id=052951e0&scoped=true"
import script from "./CaseDetailsData.vue?vue&type=script&lang=js"
export * from "./CaseDetailsData.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailsData.vue?vue&type=style&index=0&id=052951e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052951e0",
  null
  
)

export default component.exports